import React from "react"
import { StaticQuery, graphql } from "gatsby"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import { Row, Col } from "react-bootstrap"
import OurStoryPageStyle from "./our-story-page.module.scss"

const CultureValue = () => (
    <StaticQuery query={graphql`
    query OurCulture{
        contentfulOurStoryPage{
            ourStoryReference{
             sectionContent4{
                  subtitle{
                    subtitle
                      }
                  sectionParagraph{
                    json
                  }
                }
            }
          }
    }
`}
render={data => (
    <div className={OurStoryPageStyle.sectionDiv}>
        <Row>
            <Col className={OurStoryPageStyle.cultureValueCol} xs={12}>
                <h3 className={OurStoryPageStyle.sectionTitle}>{data.contentfulOurStoryPage.ourStoryReference.sectionContent4.subtitle.subtitle}</h3>
                <div className={OurStoryPageStyle.sectionDescriptionLeftAlign}>
                    {documentToReactComponents(data.contentfulOurStoryPage.ourStoryReference.sectionContent4.sectionParagraph.json)}
                </div>
            </Col>
        </Row>
    </div>
    )}
    />
)

export default CultureValue